import { render, staticRenderFns } from "./Feature.vue?vue&type=template&id=2fdbd2d3&"
import script from "./Feature.vue?vue&type=script&lang=ts&"
export * from "./Feature.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports